export default function Hero() {
  return (
    <section id="top" className="relative min-h-[640px] md:min-h-[86vh] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20editorial%20food%20magazine%20photography%20of%20vibrant%20watermelon%20and%20melons%20arranged%20on%20a%20rich%20deep%20crimson%20background%2C%20soft%20dramatic%20studio%20lighting%20with%20gentle%20highlights%2C%20juicy%20fresh%20texture%2C%20modern%20minimal%20styling%2C%20high%20end%20summer%20campaign%20aesthetic%2C%20striking%20contrast%2C%20clean%20airy%20negative%20space%2C%20no%20text&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
        alt="吃瓜网站主视觉"
        title="吃瓜网站 - 最新地址与备用入口"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-background-50"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center min-h-[640px] md:min-h-[86vh] pt-20 pb-16 md:pb-20">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 px-4 py-1.5 text-xs md:text-sm text-background-50 font-medium">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          官方 · 最新 · 备用 · 三大入口常备在线
        </span>

        <h1 className="mt-7 md:mt-9 font-heading text-4xl md:text-6xl lg:text-[68px] font-black leading-[1.15] text-background-50">
          吃瓜网站，<br className="md:hidden" />
          入口永不迷路
        </h1>

        <p className="mt-6 md:mt-7 max-w-2xl text-background-100/90 text-base md:text-lg leading-relaxed">
          官网入口、最新地址与备用入口一次收齐。无论何时何地，
          <span className="text-background-50 font-semibold">打不开、找不到网址</span>的烦恼，都从这一页重新开始。
        </p>

        <div className="mt-9 md:mt-10 flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <a
            href="#entrance"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('entrance')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 hover:bg-primary-400 text-background-50 px-8 py-3.5 text-base font-bold whitespace-nowrap transition-colors cursor-pointer"
          >
            一键直达官网入口
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="#hot"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('hot')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-background-50/95 hover:bg-background-50 text-primary-700 px-8 py-3.5 text-base font-bold whitespace-nowrap transition-colors cursor-pointer"
          >
            看看今日热榜
            <i className="ri-fire-line text-lg"></i>
          </a>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 w-full max-w-3xl">
          {[
            { n: '99.9%', t: '入口实时可用' },
            { n: '24/7', t: '地址持续同步' },
            { n: '3 条', t: '线路随时切换' },
            { n: '1000+', t: '热门内容聚合' },
          ].map((s) => (
            <div
              key={s.t}
              className="rounded-2xl bg-background-50/10 backdrop-blur-sm border border-background-50/20 px-4 py-5 md:py-6"
            >
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">{s.n}</div>
              <div className="mt-1 text-xs md:text-sm text-background-100/80">{s.t}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}